import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'

import apiCentralSeguranca from '@/api/centralseguranca'

// error pages
import AccessDenied from '@/views/layout/errors/Deny'
import NotFound from '@/views/layout/errors/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: () => import('@/components/Mapa')
    },
    {
      path: '/intranet',
      component: () => import('@/components/Mapa'),
      meta: {
        requiresAuth: true,
        groups: ['GEODER.PERFIL_PRIVADO', 'GEODER.PERFIL_ADMIN']
      }
    },
    {
      path: '/intranet/home',
      component: () => import('@/components/Mapa'),
      meta: {
        requiresAuth: true,
        groups: ['GEODER.PERFIL_PRIVADO', 'GEODER.PERFIL_ADMIN']
      }
    },
    {
      path: '/pesquisa/imagens',
      component: () => import('@/components/Imagens'),
      meta: {
        requiresAuth: true,
        groups: ['GEODER.PERFIL_PRIVADO', 'GEODER.PERFIL_ADMIN']
      }
    },
    {
      path: '/pesquisa/imagens2022',
      component: () => import('@/components/Imagens2022'),
      meta: {
        requiresAuth: true,
        groups: ['GEODER.PERFIL_PRIVADO', 'GEODER.PERFIL_ADMIN']
      }
    },
    // error pages
    {
      path: '/accessdenied',
      name: 'AccessDenied',
      component: AccessDenied,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/*',
      name: 'NotFound',
      components: {
        secundario: NotFound,
        default: NotFound
      },
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.commit('setMessages', null)

  // protected access
  if (to.meta.requiresAuth) {
    (async () => {
      if (await store.dispatch('authFilter')) {
        if (store.getters.isAuthenticated === true) {
          if (to.path === '/intranet') {
            store.commit('setLayout', 'admin')
            next('/intranet/home')
          }
          // permission groups
          if (to.meta.groups && to.meta.groups.length > 0) {
            let userData = apiCentralSeguranca.decodeJwtToken(store.getters.getJwtToken)

            if (userData.groups) {
              let permission = false; let groupName = ''
              for (let i = 0; i < userData.groups.length; i++) {
                groupName = userData.groups[i]
                if (to.meta.groups.indexOf(groupName) !== -1) {
                  permission = true
                  break
                }
              }
              if (permission) { // permission granted
                store.commit('setLayout', 'admin')
                next()
              } else { // permission denied
                store.commit('setLayout', 'blank')
                next('/accessdenied')
              }
            // eslint-disable-next-line brace-style
            }
            // Sem grupos para função que exige grupo
            else {
              store.commit('setLayout', 'blank')
              next('/accessdenied')
            }
          }
        } else {
          store.commit('limparJwtTokenState')
          store.commit('setLayout', 'blank')
          next('/accessdenied')
        }
      }
    })()
  } else {
    if (to.name === 'AccessDenied' || to.name === 'NotFound') {
      store.commit('setLayout', 'blank')
    } else {
      store.commit('setLayout', 'admin')
    }
  }

  // public access
  next()
})

export default router
